import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantity"]

  submit(event) {
    event.preventDefault()
    this.quantityTarget.form.requestSubmit()
  }

  remove() {
    this.quantityTarget.value = 0
    this.quantityTarget.form.requestSubmit()
  }
}
